export const allTransferableProducts = {
    'nalll'          : 'logo-nalll-blue.svg',
    'ncomply'        : 'logo-nrule-blue.svg',
    'ncomply v2'     : 'logo-ncomply-blue.svg',
    'ncontinuity'    : 'logo-ncontinuity-blue.svg',
    'ncontracts'     : 'logo-contracts-blue.svg',
    'ncontracts 2.0' : 'logo-contracts-blue.svg',
    'nrisk'          : 'logo-nrisk-blue.svg',
    'nvendor'        : 'logo-nvendor-blue.svg',
    'nvendor plus'   : 'logo-nvendorPlus-blue.svg',
    'nvendor premium': 'logo-nvendorpremium-blue.svg',
    'scout'          : 'logo-scout-blue.svg',
    'scout-ncyber'   : 'logo-ncyber-blue.svg',
    'workflow'       : 'logo-workflow-blue.svg',
    'trupoint'       : 'logo-ntrupoint.svg'
};
